import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';

/**
 * What moving a booking to another person did. An overlap with a booking the new person already has is
 * reported instead of refused: admins merge duplicate persons through this and need the doubled bookings
 * until they removed one of them.
 */
@Entity()
export class BookingReassignResult extends AdornisEntity {
  static override _class = 'BookingReassignResult';

  constructor(doc: PartialEntityData<BookingReassignResult>) {
    super(doc);
  }

  @Field(() => Int)
  endedMandates!: number;

  @Field(() => Boolean)
  overlapping!: boolean;
}
